(function(){

    var prevScrollpos = window.pageYOffset;
    window.onscroll = function() {
        var currentScrollPos = window.pageYOffset;
        if (prevScrollpos > currentScrollPos) {
            document.getElementById("header").style.top = "0";
        } else {
            document.getElementById("header").style.top = "-70px";
        }
        prevScrollpos = currentScrollPos;
    }

})();


(function () {
    let openMenu = null;
    let openToggler = null;

    function onKeydown(e) {
        if (e.key === 'Escape') closeNav();
    }

    window.openNav = function (togglerEl) {
        const navbar = togglerEl.closest('.navbar');
        if (!navbar) return;

        const menu = navbar.querySelector('.navbar-collapse');
        if (!menu) return;

        // toggle
        const isOpen = menu.classList.contains('show');
        if (isOpen) {
            closeNav();
            return;
        }

        // chiudi eventuale altro menu aperto
        if (openMenu && openMenu !== menu) closeNav();

        openMenu = menu;
        openToggler = togglerEl;

        // se nel markup per caso resta d-none, lo sblocchiamo
        menu.classList.remove('d-none');

        document.body.classList.add('nav-open');
        menu.classList.add('show');

        togglerEl.setAttribute('aria-expanded', 'true');
        menu.setAttribute('aria-hidden', 'false');

        document.addEventListener('keydown', onKeydown);

        togglerEl.classList.add('is-active');
    };

    window.closeNav = function () {
        if (!openMenu) return;

        openMenu.classList.remove('show');
        openMenu.setAttribute('aria-hidden', 'true');

        if (openToggler) openToggler.setAttribute('aria-expanded', 'false');

        document.body.classList.remove('nav-open');
        document.removeEventListener('keydown', onKeydown);

        openToggler?.classList.remove('is-active');

        openMenu = null;
        openToggler = null;
    };

    // Safety: su desktop chiudi overlay
    window.addEventListener('resize', function () {
        if (window.innerWidth >= 992) closeNav();
    });
})();
